<template>
  <section>
    <button
      class="absolute top-3 right-3 p-3 rounded-full z-50"
      @click="onClose"
    >
      <img src="../assets/images/close_btn.png" alt="close" class="w-6" />
    </button>
    <div v-if="videoItems.length <= 1" class="max-h-screen">
      <audio
        v-if="isAudio && !withModel"
        controls
        :src="`${baseApiUrl}/api/files/load/${audioSrc}`"
        class="audio"
        id="audio"
      ></audio>
      <video
        v-if="isSavePopup != true"      
        controls
        playsinline
        ref="videoEl"
        @canplay="updatePaused"
        @playing="updatePaused"
        @pause="updatePaused"
        @ended="onNextLink"
      >
        <source
          :src="`${baseApiUrl}/api/files/load/${videoSrc}`"
          type="video/mp4"
        />
        죄송합니다. 해당 브라우저는 비디오를 지원하지 않습니다.
      </video>
    </div>
    <div v-else>
      <swiper
        v-if="isSavePopup != true"
        :slides-per-view="1"
        :pagination="{
          dynamicBullets: true,
        }"
        :modules="modules"
        class="max-h-screen"
      >
        <swiper-slide v-for="(item, index) in videoItems" :key="index">
          <video
            controls
            playsinline
            class="videoEl"
            @canplay="updatePaused"
            @playing="updatePaused"
            @pause="updatePaused"
            @ended="onNextLink"
          >
            <source
              :src="`${baseApiUrl}/api/files/load/${item}`"
              type="video/mp4"
            />
            죄송합니다. 해당 브라우저는 비디오를 지원하지 않습니다.
          </video>
        </swiper-slide>
      </swiper>
      <div v-if="isPopup == true" class="popup" @click="isPopup = false">
        <img
          src="../assets/images/swipe.png"
          alt="좌우로 넘겨 영상을 감상하실 수 있습니다."
        />
      </div>
    </div>
    <div v-if="isSavePopup == true" class="popup">
      <img
        src="../assets/images/save.png"
        alt="도감에 저장되었습니다."
      />
    </div>          
  </section>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue.js";
import { Pagination, Navigation } from "swiper";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";

// Import vuex
import { mapGetters } from "vuex";

// Import service
import service from "../services";

export default {
  props: {
    type: {
      type: String,
      default: "relic",
    },    
    video: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },    
    isRelicsSave: {
      type: Boolean,
      default: true,
    },      
    isAudio: {
      type: Boolean,
      default: false,
    },
    audio: {
      type: Object,
      default: () => {},
    },
    withModel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      videoEl: null,
      paused: true,
      videoSrc: "",
      audioSrc: "",
      videoItems: [],
      modules: [Pagination, Navigation],
      currentVideo: 0,
      baseApiUrl: process.env.VUE_APP_BASE_API_URL,
      isPopup: true,
      isSavePopup: false,
      saveTimer : null
    };
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
    ]),    
    playing() {
      this.videoEl.webkitRequestFullscreen();
      return !this.paused;
    },
  },
  created() {
    this.$store.commit("saveIsVideo", true);
  },
  unmounted() {
    clearTimeout(this.saveTimer);
    this.saveTimer = null;
  },
  mounted() {
    this.videoEl = this.$refs.videoEl;
    this.getVideoSrc();
    this.getAudioSrc();
  },
  methods: {
    onClose() {
      if (this.withModel) {
        this.$emit("showARScene", false);
      } else {
        this.$router.push({ name: "Antiquity", params: { reload: true } });
      }
    },
    updatePaused(event) {
      this.paused = event.target.paused;
      this.videoEl.webkitRequestFullscreen();
    },
    play(index) {
      if (typeof index == "number") {
        const videoEls = this.$el.querySelectorAll(".videoEl");
        videoEls[index].play();
        this.currentVideo = index;
      } else {
        this.videoEl.play();
      }
    },
    pause(index) {
      if (typeof index == "number") {
        const videoEls = document.querySelectorAll(".videoEl");
        videoEls[index].pause();
        this.videoIndex = index;
      } else {
        this.videoEl.pause();
      }
    },
    async onNextLink() {
      if ( this.type != 'album' && this.isRelicsSave ) {
        console.log(this.item);
        if ( this.item.arUse == "Y" && this.item.model.length == 0 ) {
          if ( this.isAuthenticated ) {
            // 로그인 되어 있음
            const regparams = {
              relicsId: this.item.id,
            };
            
            await service.regUserRelics(regparams).then(
              (response) => {
                console.log(response);
                if (response.status == 200) {
                  clearTimeout(this.saveTimer);
                  this.isSavePopup = true;
                  this.saveTimer = setTimeout(() => {
                    this.isSavePopup = false;
                    if (this.withModel) {
                      this.$emit("showARScene", false);
                    }
                  }, 3000);
                } else {
                  if (this.withModel) {
                    this.$emit("showARScene", false);
                  }              
                }
              },
              (error) => {
                const { data } = error.response;
                console.log(data);
                if (this.withModel) {
                  this.$emit("showARScene", false);
                }            
              }
            );
          } else {
            if (window.confirm("도감에 저장하시겠습니까?")) {
              // 로그인 화면으로 이동
              this.$router.push({ name: "Login", params: { reload: true } });
            } else {
              // 로그인 필요
              clearTimeout(this.saveTimer);
              this.isSavePopup = true;
              console.log(this.isSavePopup);
              this.saveTimer = setTimeout(() => {
                this.isSavePopup = false;
                if (this.withModel) {
                  this.$emit("showARScene", false);
                }
              }, 3000);            
            }
          }
        } else {
          if (this.withModel) {
            this.$emit("showARScene", false);
          }
        }
      } else {
        if (this.withModel) {
          this.$emit("showARScene", false);
        }
      }
    },
    getVideoSrc() {
      if (this.video.ko.length <= 1) {
        if (this.$i18n.locale == "en" && this.video.en != "") {
          this.videoSrc = this.video.en[0];
        } else if (this.$i18n.locale == "zh" && this.video.zh != "") {
          this.videoSrc = this.video.zh[0];
        } else if (this.$i18n.locale == "ja" && this.video.ja != "") {
          this.videoSrc = this.video.ja[0];
        } else if (this.$i18n.locale == "child" && this.video.child != "") {
          this.videoSrc = this.video.child[0];
        } else {
          this.videoSrc = this.video.ko[0];
        }
      } else {
        if (this.$i18n.locale == "en" && this.video.en != "") {
          this.videoItems = this.video.en;
        } else if (this.$i18n.locale == "zh" && this.video.zh != "") {
          this.videoItems = this.video.zh;
        } else if (this.$i18n.locale == "ja" && this.video.ja != "") {
          this.videoItems = this.video.ja;
        } else if (this.$i18n.locale == "child" && this.video.child != "") {
          this.videoItems = this.video.child;
        } else {
          this.videoItems = this.video.ko;
        }
      }
    },
    getAudioSrc() {
      if (this.isAudio) {
        if (this.$i18n.locale == "en" && this.audio.en) {
          this.audioSrc = this.audio.en;
        } else if (this.$i18n.locale == "zh" && this.audio.zh) {
          this.audioSrc = this.audio.zh;
        } else if (this.$i18n.locale == "ja" && this.audio.ja) {
          this.audioSrc = this.audio.ja;
        } else if (this.$i18n.locale == "child" && this.audio.child) {
          this.audioSrc = this.audio.child;
        } else {
          this.audioSrc = this.audio.ko;
        }
      }
    },
  },
};
</script>

<style>
video {
  height: 100vh;
}
.play_btn,
.next_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #93c5fd;
  padding: 10px;
  color: #000;
  border: none;
  border-radius: 1.5rem;
  outline: none;
  font-size: 1rem;
  font-weight: 500;
}
.next_btn::after {
  content: "";
  width: 0.6rem;
  height: 0.6rem;
  border-top: 1.6px solid #000;
  border-right: 1.6px solid #000;
  display: block;
  transform: rotate(45deg);
}
.audio {
  position: absolute;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 30vw;
  height: 2rem;
  z-index: 999;
}
audio::-webkit-media-controls-panel {
  background-color: rgba(0, 0, 0, 0.1);
}
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal {
  bottom: auto;
  top: 1rem;
}
.popup {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(2px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup img {
  width: 80%;
}
</style>
